module.exports = __webpack_public_path__ + "img/主图.9a43a0ca.jpg";